import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ContactFooterModule",
    component: () =>
        __SERVER__ ? require("./contact-footer-module-view") : import("./contact-footer-module-view")
});

export default definition;
